<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
      showHelp
      :helpText='helpText'
    >
      <template v-slot:appendTitle>
        <span
          class='caption ml-1 grey--text font-italic'
          style='letter-spacing: -0.4px !important;'
        >
          (already reflected in quote)
        </span>
      </template>
      <v-card-text class='py-1 d-flex'>
        <span class='text-subtitle-2 mr-2' style='white-space: nowrap'>1:</span>
        <span v-if='!estimateDetail.misc_opt_1' class='grey--text text--lighten-1'>None...</span>
        <span v-else v-html='estimateDetail.misc_opt_1'></span>
        <v-spacer></v-spacer>
        <span v-if='estimateDetail.misc_opt_1'>{{ getOption(estimateDetail.misc_opt_1_selection) }}</span>
      </v-card-text>
      <v-card-text class='py-1 d-flex'>
        <span class='text-subtitle-2 mr-2' style='white-space: nowrap'>2:</span>
        <span v-if='!estimateDetail.misc_opt_2' class='grey--text text--lighten-1'>None...</span>
        <span v-else v-html='estimateDetail.misc_opt_2'></span>
        <v-spacer></v-spacer>
        <span v-if='estimateDetail.misc_opt_2'>{{ getOption(estimateDetail.misc_opt_2_selection) }}</span>
      </v-card-text>
      <v-card-text class='py-1 d-flex'>
        <span class='text-subtitle-2 mr-2' style='white-space: nowrap'>3:</span>
        <span v-if='!estimateDetail.misc_opt_3' class='grey--text text--lighten-1'>None...</span>
        <span v-else v-html='estimateDetail.misc_opt_3'></span>
        <v-spacer></v-spacer>
        <span v-if='estimateDetail.misc_opt_3'>{{ getOption(estimateDetail.misc_opt_3_selection) }}</span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      width='600'
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-row>
        <v-col cols='9'>
          <v-text-field
            label='Misc. Option 1'
            v-model='estimateDetailCopy.misc_opt_1'
            counter
            maxlength='55'
          ></v-text-field>
        </v-col>
        <v-col cols='3'>
          <v-select :items='choices' v-model='estimateDetailCopy.misc_opt_1_selection'></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='9'>
          <v-text-field
            label='Misc. Option 2'
            v-model='estimateDetailCopy.misc_opt_2'
            counter
            maxlength='55'
          ></v-text-field>
        </v-col>
        <v-col cols='3'>
          <v-select :items='choices' v-model='estimateDetailCopy.misc_opt_2_selection'></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='9'>
          <v-text-field
            label='Misc. Option 3'
            v-model='estimateDetailCopy.misc_opt_3'
            counter
            maxlength='55'
          ></v-text-field>
        </v-col>
        <v-col cols='3'>
          <v-select :items='choices' v-model='estimateDetailCopy.misc_opt_3_selection'></v-select>
        </v-col>
      </v-row>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'irrigation-estimate-options',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    title: 'Misc. Options',
    icon: 'mdi-format-list-checks',
    iconColor: 'primary',
    estimateDetailCopy: {},
    showDialog: false,
    helpText: "These options will appear in the 'Specific Components' box at the top half of the estimate printout and are already included in the quote amount.<br><br>No action tracker or line items will be added to an invoice for these options.<br><br>In general, these items are for explanation (to either the crew, or the office) of already-agreed-upon scope that the estimator has discussed with the client and has already been reflected by quote amount."
  }),
  computed: {
    choices () {
      return this.$store.state.misc.globalOptions.estimateOptionals
    }
  },
  methods: {
    openEdit () {
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    save () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.showDialog = false
    },
    getOption (val) {
      let tmp = _.find(this.choices, function (c) { return c.value === val })
      if (tmp) {
        return tmp.text
      }
      return ''
    }
  },
  components: {

  }
}
</script>